import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import CustomizeAppearance from '../../components/company/customize-appearance';

function CompanyAppearance() {
    const { store, brandingStore } = useStores();

    const { currentCompany } = store;

    const saveColor = async (primaryColor, secondaryColor) => {
        await store.saveCurrentCompany({
            'ui.colors.primary': primaryColor,
            'ui.colors.secondary': secondaryColor,
        });
        
        const uiSettings = Object.fromEntries(
            Object.entries(store.currentCompany.settings).filter(([key]) => key.startsWith('ui.'))
        );
        brandingStore.updateBranding(uiSettings);
    };

    const resetToDefaults = async () => {
        let result = await store.saveCurrentCompany({
            'ui.colors.primary': null,
            'ui.colors.secondary': null,
            logoName: null,
        });

        const uiSettings = Object.fromEntries(
            Object.entries(store.currentCompany.settings).filter(([key]) => key.startsWith('ui.'))
        );
        brandingStore.updateBranding(uiSettings);
        
        return result;
    };

    const importLogo = async (formData) => {
        await store.uploadCurrentCompanyLogo(formData);
    };

    const removeLogo = async () => {
        await store.removeCurrentCompanyLogo();
    };

    return (
        <CustomizeAppearance
            company={currentCompany}
            saveColor={saveColor}
            resetToDefaults={resetToDefaults}
            importLogo={importLogo}
            removeLogo={removeLogo}
            uploadingLogo={store.uploadingCurrentCompanyLogo}
            saving={store.savingCurrentCompany}
        />
    );
}

export default observer(CompanyAppearance);
